import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AuthenticationService } from "app/shared/services/authentication-service";
import { SharedService } from 'app/shared/services/shared.service';
import { User } from 'app/shared/models/User';
import { AccountService } from 'app/core/services/account.service';

@Injectable()
export class AdminGuard implements CanActivate {
    user: User;

    constructor(
        private _router: Router, private authentication: AuthenticationService,
        private accountService: AccountService,
        private sharedService: SharedService
    ) { }

    canActivate(route: Object, state: Object): boolean {

        this.accountService.getUser().subscribe(
            user => {
                this.user = user;
                if (!this.user.isAdmin) {
                    this._router.navigate(['/dashboard']);
                    return false;
                }
            });
        return true;
    }



}
